<template>
  <div class="w-full flex flex-col px-6 mt-16">
    <div class="slider-cont w-full">
      <div class="slider-wrapper relative">
        <VueSlickCarousel
          ref="itemAwakeningSlider"
          v-bind="settings"
          @beforeChange="beforeChangeCarousel"
        >
          <div class="slide">
            <div class="flex flex-col justify-center items-center">
              <h1
                class="w-full text-center font-rakkas 3sm:text-8.4xl xs:text-5 text-white"
              >
                Guild Rework
              </h1>
              <span
                class="3sm:w-208 3sm:h-3.5 xs:w-60 xs:h-8 text-center bg-vivid-pink font-mulish-bold text-white 3sm:text-1.8 xs:text-1.4 leading-1.6 3sm:tracking-wider xs:tracking-normal py-1 flex items-center justify-center 3sm:mt-12 xs:mt-8"
                >1. New Guild Menu</span
              >
            </div>
            <div class="w-full mt-14">
              <img
                class="w-full"
                :src="`${imgPath}/SystemChanges/guildrework_1.png`"
              />
            </div>
            <p
              class="text-center font-mulish-medium text-very-pale-orange 3sm:text-2 xs:text-1.2 3sm:leading-2.2 xs:leading-1.4 tracking-wider mt-14"
            >
              * Available in towns only
            </p>
          </div>
          <div class="slide">
            <div class="flex flex-col justify-center items-center">
              <span
                class="3sm:w-208 3sm:h-3.5 xs:w-60 xs:h-8 text-center bg-vivid-pink font-mulish-bold text-white 3sm:text-1.8 xs:text-1.4 leading-1.6 3sm:tracking-wider xs:tracking-normal py-1 flex items-center justify-center mt-12"
                >2. Guild Registration</span
              >
              <div class="mt-14">
                <img
                  class="w-full"
                  :src="`${imgPath}/SystemChanges/guildrework_2.png`"
                />
              </div>
              <p
                class="font-mulish-medium text-very-pale-orange 3sm:text-1.8 xs:text-1.2 leading-2 tracking-wider 3sm:mt-14 xs:mt-4 text-center"
              >
                You can see the list of recommended guilds, and you can also
                check the methods (free entry / approved entry) of joining.
              </p>
            </div>
          </div>
          <div class="slide">
            <div class="flex flex-col justify-center items-center">
              <span
                class="3sm:w-208 3sm:h-3.5 xs:w-60 xs:h-8 text-center bg-vivid-pink font-mulish-bold text-white 3sm:text-1.8 xs:text-1.4 leading-1.6 tracking-wider py-1 flex items-center justify-center mt-12"
                >3. Guild Window</span
              >
              <div class="mt-14 w-full flex justify-center">
                <img
                  class="3sm:w-10/12 xs:w-full"
                  :src="`${imgPath}/SystemChanges/guildrework_3.png`"
                />
              </div>
              <div class="w-full flex justify-center items-center mt-12">
                <div
                  class="flex justify-center items-center p-3 bg-white rounded-3xl"
                >
                  <div
                    class="h-full flex justify-center items-center bg-very-pale-orange rounded-2xl shadow-sc-box 3sm:p-11 xs:p-6"
                  >
                    <ul
                      class="list-none h-full flex flex-col justify-center items-start"
                    >
                      <li
                        class="w-full flex flex-row mt-1 first:mt-0"
                        v-for="(item, index) in guildRework3"
                        :key="index"
                      >
                        <div class="w-1/12">
                          <span
                            v-if="item.order"
                            class="bg-vivid-pink 3sm:w-2.8 3sm:h-2.8 xs:w-10 xs:h-10 font-mulish-bold 3sm:text-1.4 xs:text-1.2 text-white flex justify-center items-center 3sm:rounded-2xl xs:rounded-xl"
                            v-html="item.order"
                          ></span>
                        </div>
                        <p
                          :class="
                            item.order
                              ? 'text-very-dark-gray'
                              : 'text-strong-red'
                          "
                          class="2sm:ml-0 xs:ml-5 pt-2 font-mulish-semibold text-very-dark-gray 3sm:text-1.4 xs:text-1.2"
                          v-html="item.desc"
                        ></p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slide">
            <div class="flex flex-col justify-center items-center">
              <span
                class="3sm:w-208 3sm:h-3.5 xs:w-60 xs:h-8 text-center bg-vivid-pink font-mulish-bold text-white 3sm:text-1.8 xs:text-1.4 leading-1.6 3sm:tracking-wider xs:tracking-normal py-1 flex items-center justify-center 3sm:mt-12 xs:mt-8"
                >4. Guild Missions</span
              >
              <div class="mt-14 w-full flex justify-center">
                <img
                  class="3sm:w-10/12 xs:w-full"
                  :src="`${imgPath}/SystemChanges/guildrework_4.png`"
                />
              </div>
              <p
                class="text-center font-mulish-medium text-very-pale-orange 3sm:text-2 xs:text-1.2 3sm:leading-2.2 xs:leading-1.4 tracking-wider 3sm:mt-14 xs:mt-6"
              >
                Guild members can collect guild points for a week to earn
                step-by-step rewards. Guild missions reset every week. Rewards
                can be earned from guild missions conducted the previous week,
                and only collect once per account. (Button disabled after
                claiming rewards)
              </p>
            </div>
          </div>
          <div class="slide">
            <div class="flex flex-col justify-center items-center">
              <span
                class="3sm:w-208 3sm:h-3.5 xs:w-60 xs:h-8 text-center bg-vivid-pink font-mulish-bold text-white 3sm:text-1.8 xs:text-1.4 leading-1.6 3sm:tracking-wider xs:tracking-normal py-1 flex items-center justify-center 3sm:mt-12 xs:mt-8"
                >5. Guild Management</span
              >
              <div class="mt-14 w-full flex justify-center">
                <img
                  class="3sm:w-10/12 xs:w-full"
                  :src="`${imgPath}/SystemChanges/guildrework_5.png`"
                />
              </div>
              <p
                class="text-center font-mulish-medium text-very-pale-orange 3sm:text-2 xs:text-1.2 3sm:leading-2.2 xs:leading-1.4 tracking-wider 3sm:mt-14 xs:mt-6 md:w-11/12"
              >
                You can set a guild slogan, prerequisites, and recruit new
                members through the 'Manage Guild' tab. Some functions have been
                moved to this menu from the Guild NPC.
              </p>
              <p
                class="font-mulish-medium text-strong-red 3sm:text-1.8 xs:text-1.2 3sm:leading-1.8 xs:leading-1.4 tracking-wider 3sm:mt-8 xs:mt-4 text-center md:w-10/12"
              >
                ! This button is disabled for guild members who do not have the
                permissions.
              </p>
            </div>
          </div>
        </VueSlickCarousel>
        <div class="w-full flex justify-center mt-5">
          <div
            class="w-440 flex justify-center items-center px-4 h-54 bg-black bg-opacity-30 rounded-3xl"
          >
            <span
              :class="
                index === activeSlide
                  ? 'bg-dark-moderate-violet'
                  : 'bg-very-dark-violet'
              "
              class="w-6 h-6 rounded-full mx-5 z-10 cursor-pointer"
              v-for="(item, index) in [0, 1, 2, 3, 4]"
              :key="index"
              @click="goToSlide(index)"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  components: { VueSlickCarousel },
  data: function() {
    return {
      activeSlide: 0,
      settings: {
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },
  methods: {
    beforeChangeCarousel: function(oldIndex, newIndex) {
      this.activeSlide = newIndex;
    },
    goToSlide: function(index) {
      this.activeSlide = index;
      this.$refs.itemAwakeningSlider.goTo(index);
    },
  },
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
      guildRework3: state => state.SystemChanges.guildRework3,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.slider-wrapper >>> .slick-track {
  @apply flex justify-center items-center !important;
}
</style>
